(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["24seven-dark-mode"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.documentElement;
  const key = '24seven-color-mode';
  const system = matchMedia('(prefers-color-scheme: dark)');
  const saved = () => { try { return localStorage.getItem(key); } catch (_) { return null; } };
  const sync = () => document.querySelectorAll('[data-seven-color-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.sevenColorChoice === root.dataset.sevenMode)));
  const apply = mode => { root.dataset.sevenMode = mode === 'dark' ? 'dark' : 'light'; sync(); };
  sync();
  document.addEventListener('DOMContentLoaded', sync, {once: true});
  window.addEventListener('pageshow', sync);
  document.addEventListener('click', event => {
    const button = event.target instanceof Element ? event.target.closest('[data-seven-color-choice]') : null;
    if (!button) return;
    const mode = button.dataset.sevenColorChoice;
    apply(mode);
    try { localStorage.setItem(key, mode); } catch (_) {}
  });
  document.addEventListener('shopify:section:load', sync);
  system.addEventListener('change', () => { if (!saved()) apply(system.matches ? 'dark' : 'light'); });
  window.addEventListener('storage', event => { if (event.key === key) apply(event.newValue || (system.matches ? 'dark' : 'light')); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["24seven-gift-finder"] && !Shopify.designMode) return;
  try {
    function sevenNormalize(value) {
  return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9 ]/g, ' ').replace(/\s+/g, ' ').trim();
}
function sevenGiftIntent(description, budget) {
  const normalized = sevenNormalize(description);
  const words = new Set(normalized.split(' '));
  const groups = [
    { aliases: ['rosa','rosas','rose','roses'], weight: 5, material: true },
    { aliases: ['girasol','girasoles'], weight: 5, material: true },
    { aliases: ['hortensia','hortensias'], weight: 5, material: true },
    { aliases: ['tulipan','tulipanes'], weight: 5, material: true },
    { aliases: ['orquidea','orquideas'], weight: 5, material: true },
    { aliases: ['lirio','lirios','lily','lilies'], weight: 5, material: true },
    { aliases: ['rojo','roja','rojos','rojas','red'], weight: 3 },
    { aliases: ['rosado','rosada','rosados','rosadas','pink'], weight: 3 },
    { aliases: ['fucsia','fucsias'], weight: 3 },
    { aliases: ['blanco','blanca','blancos','blancas','white'], weight: 3 },
    { aliases: ['amarillo','amarilla','amarillos','amarillas','yellow'], weight: 3 },
    { aliases: ['morado','morada','morados','moradas','lila','lilas','lavanda'], weight: 3 },
    { aliases: ['chocolate','chocolates','ferrero'], weight: 5, required: true },
    { aliases: ['peluche','peluches','osito','ositos','oso','osos'], weight: 5, required: true },
    { aliases: ['globo','globos','balloon','balloons'], weight: 4, required: true },
    { aliases: ['ramo','ramos','bouquet','bouquets'], weight: 4 },
    { aliases: ['arreglo','arreglos','arrangement','arrangements'], weight: 3 },
    { aliases: ['floral','florales','flores','flor','flowers','flower'], matches: ['floral','florales','flores','flor','flowers','flower','rosas','ramo','ramos','girasol','girasoles','hortensia','hortensias','tulipan','tulipanes','orquidea','orquideas','lirio','lirios'], weight: 2, flowers: true },
    { aliases: ['fruta','frutas','frutal','frutales'], weight: 5 },
    { aliases: ['canasta','canastas','cesta','cestas'], weight: 4 },
    { aliases: ['cumpleanos','cumple','birthday'], weight: 2 },
    { aliases: ['aniversario','aniversarios','romantico','romantica','romanticos','romanticas','amor','pareja','novia','novio'], weight: 2 },
    { aliases: ['condolencias','condolencia','funebre','funebres','funeral','funerales','luto','duelo'], weight: 8 },
    { aliases: ['vela','velas','candle','candles'], weight: 5 }
  ];
  const selected = groups.filter(group => group.aliases.some(alias => words.has(alias))).map(group => {
    const excluded = group.aliases.some(alias => new RegExp(`(?:sin|no quiero|no deseo) (?:un |una |el |la )?${alias}(?: |$)`).test(normalized));
    return {...group, excluded};
  });
  const known = new Set(groups.flatMap(group => group.aliases));
  const stops = new Set('un una unos unas el la los las de del con para por y o que quiero busco buscar necesito gustaria regalar regalo regalos detalle detalles bonito bonita bonitos bonitas especial especiales algo tipo como me mi mis tu su sus a al en es sea ser tengo hasta menos mas dolares dolar presupuesto maximo maximos aproximadamente opciones opcion mama madre papa padre amiga amigo mujer hombre persona gracias estoy contigo te ti sientes siente grande pequeno mediano sin no deseo'.split(' '));
  const terms = [...words].filter(word => word.length > 2 && !known.has(word) && !stops.has(word) && !/^\d+$/.test(word));
  const amount = description.match(/(?:\$\s*|(?:hasta|menos de|maximo|presupuesto(?: de)?|por)\s*\$?\s*)(\d+(?:[.,]\d{1,2})?)/i);
  const max = budget ? Number(budget) : amount ? Number(amount[1].replace(',', '.')) : null;
  return { selected, terms, max: Number.isFinite(max) && max > 0 ? max * 100 : null };
}
function sevenRankGifts(products, intent) {
  const positives = intent.selected.filter(group => !group.excluded);
  const funeral = positives.some(group => group.aliases.includes('condolencias'));
  return products.map(product => {
    const title = new Set(sevenNormalize(product.title).split(' '));
    const details = new Set(sevenNormalize([product.title,product.description,product.tags,product.type].join(' ')).split(' '));
    const body = new Set(sevenNormalize([product.title,product.description,product.tags,product.type,product.collections].join(' ')).split(' '));
    if (intent.max !== null && product.price > intent.max) return null;
    if (intent.selected.some(group => group.excluded && (group.matches || group.aliases).some(alias => details.has(alias)))) return null;
    if (positives.some(group => group.flowers) && !positives.find(group => group.flowers).matches.some(alias => details.has(alias))) return null;
    if (positives.some(group => group.required && !group.aliases.some(alias => details.has(alias)))) return null;
    const materials = positives.filter(group => group.material);
    if (materials.length && !materials.some(group => group.aliases.some(alias => details.has(alias)))) return null;
    if (!funeral && ['condolencias','funebre','funeral'].some(word => body.has(word))) return null;
    let score = 0;
    let matches = 0;
    for (const group of positives) {
      const aliases = group.matches || group.aliases;
      if (aliases.some(alias => body.has(alias))) {
        matches++;
        score += group.weight * (aliases.some(alias => title.has(alias)) ? 3 : 1);
      }
    }
    for (const term of intent.terms) {
      if (body.has(term)) { score += title.has(term) ? 9 : 3; matches++; }
    }
    if (positives.length + intent.terms.length > 0 && matches === 0) return null;
    if (funeral && !['condolencias','condolencia','funebre','funebres','funeral','funerales','luto','duelo'].some(word => body.has(word))) return null;
    score += matches * 5;
    return {product, score};
  }).filter(Boolean).sort((a,b) => b.score - a.score || a.product.price - b.product.price).slice(0,6).map(item => item.product);
}
if (!customElements.get('seven-gift-finder')) {
  customElements.define('seven-gift-finder', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.events) return;
        this.events = new AbortController();
        const signal = this.events.signal;
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        this.input = this.querySelector('textarea');
        this.budget = this.querySelector('input');
        this.grid = this.querySelector('ul');
        this.status = this.querySelector('[role="status"]');
        this.results = this.querySelector('.seven-finder__results');
        this.submit = this.querySelector('[type="submit"]');
        this.guidance = this.querySelector('.seven-finder__guidance');
        this.sequence = 0;
        document.addEventListener('click', event => {
          const trigger = event.target.closest('[data-seven-finder-open]');
          if (!trigger || !this.dialog || this.dialog.open || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.trigger = trigger;
          this.dialog.classList.remove('is-closing');
          this.dialog.showModal();
          document.body.classList.add('seven-finder-open');
          this.input.focus({preventScroll:true});
        }, {signal});
        this.querySelector('[data-seven-close]').addEventListener('click', () => this.close(), {signal});
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, {signal});
        this.dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const focusable = [...this.dialog.querySelectorAll('a[href],button:not(:disabled),input:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])')].filter(element => element.getClientRects().length > 0);
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        }, {signal});
        this.dialog.addEventListener('pointerdown', event => { this.backdropPressed = this.outside(event); }, {signal});
        this.dialog.addEventListener('click', event => { if (this.backdropPressed && this.outside(event)) this.close(); this.backdropPressed = false; }, {signal});
        this.dialog.addEventListener('close', () => {
          document.body.classList.remove('seven-finder-open');
          this.trigger?.focus({preventScroll:true});
        }, {signal});
        this.form.addEventListener('submit', event => { event.preventDefault(); this.search(); }, {signal});
        this.querySelectorAll('[data-seven-query]').forEach(button => button.addEventListener('click', () => {
          this.input.value = button.dataset.sevenQuery;
          this.form.requestSubmit();
        }, {signal}));
      });
    }
    outside(event) {
      const rect = this.dialog.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    }
    async close() {
      if (!this.dialog.open || this.closing) return;
      this.closing = true;
      this.sequence++;
      this.request?.abort();
      this.results.setAttribute('aria-busy','false');
      this.submit.disabled = false;
      if (this.status.textContent === this.dataset.loading) this.status.textContent = '';
      this.dialog.classList.add('is-closing');
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
        await this.dialog.animate([{opacity:1,transform:'translateY(0) scale(1)'},{opacity:0,transform:'translateY(12px) scale(.98)'}],{duration:180,easing:'ease-in',fill:'forwards'}).finished.catch(() => {});
      }
      this.dialog.close();
      this.dialog.getAnimations().forEach(animation => animation.cancel());
      this.dialog.classList.remove('is-closing');
      this.closing = false;
    }
    async catalogData(signal) {
      if (this.catalog) return this.catalog;
      const root = window.Shopify?.routes?.root || '/';
      let url = new URL(root,location.origin);
      url.searchParams.set('section_id','24seven-finder-catalog');
      const products = new Map();
      const visited = new Set();
      while (url) {
        if (visited.has(url.href) || url.origin !== location.origin) throw new Error('Invalid catalog pagination');
        visited.add(url.href);
        const response = await fetch(url,{signal,credentials:'same-origin',headers:{Accept:'text/html'}});
        if (!response.ok) throw new Error('Catalog unavailable');
        const document = new DOMParser().parseFromString(await response.text(),'text/html');
        const data = document.querySelector('[data-seven-catalog]');
        if (!data) throw new Error('Catalog missing');
        for (const product of JSON.parse(data.dataset.products)) products.set(product.id,product);
        url = data.dataset.next ? new URL(data.dataset.next,location.origin) : null;
        if (url) url.searchParams.set('section_id','24seven-finder-catalog');
      }
      this.catalog = [...products.values()];
      return this.catalog;
    }
    async search() {
      if (!this.input.value.trim()) { this.input.value = ''; this.input.reportValidity(); return; }
      this.request?.abort();
      this.request = new AbortController();
      const request = this.request;
      const sequence = ++this.sequence;
      const timeout = setTimeout(() => request.abort(),15000);
      this.results.setAttribute('aria-busy','true');
      this.submit.disabled = true;
      this.grid.replaceChildren();
      this.guidance.hidden = true;
      this.status.textContent = this.dataset.loading;
      try {
        const intent = sevenGiftIntent(this.input.value,this.budget.value);
        const products = sevenRankGifts(await this.catalogData(request.signal),intent);
        if (sequence !== this.sequence || !this.dialog.open) return;
        this.status.textContent = products.length ? this.dataset.count.replace('SEVEN_COUNT',products.length) : this.dataset.empty;
        this.guidance.hidden = products.length > 0;
        const fragment = document.createDocumentFragment();
        products.forEach((product,index) => {
          const url = new URL(product.url,location.origin);
          if (url.origin !== location.origin || !url.pathname.includes('/products/')) return;
          const li = document.createElement('li');
          li.className = 'seven-finder__card';
          li.setAttribute('data-seven-glass', '');
          li.style.animationDelay = `${index * 45}ms`;
          const link = document.createElement('a');
          link.href = url.href;
          if (product.image) {
            const imageUrl = new URL(product.image,location.origin);
            if (imageUrl.protocol === 'https:') {
              const image = document.createElement('img');
              image.src = imageUrl.href;
              image.alt = '';
              image.width = 300;
              image.height = 300;
              image.loading = 'lazy';
              link.append(image);
            }
          }
          const title = document.createElement('h3');
          title.textContent = product.title;
          const price = document.createElement('p');
          price.textContent = product.money;
          const action = document.createElement('span');
          action.textContent = `${this.dataset.view} ↗`;
          link.append(title,price,action);
          li.append(link);
          fragment.append(li);
        });
        this.grid.append(fragment);
        if (matchMedia('(max-width: 749px)').matches) {
          const top = this.dialog.scrollTop + this.results.getBoundingClientRect().top - this.dialog.getBoundingClientRect().top - 72;
          this.dialog.scrollTo({top:Math.max(0,top),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }
      } catch (error) {
        if (sequence === this.sequence && this.dialog.open) { this.status.textContent = this.dataset.error; this.guidance.hidden = false; }
      } finally {
        clearTimeout(timeout);
        if (sequence === this.sequence) { this.results.setAttribute('aria-busy','false'); this.submit.disabled = false; }
      }
    }
    disconnectedCallback() {
      this.sequence++;
      this.events?.abort();
      this.events = null;
      this.request?.abort();
      if (this.dialog?.open) { this.dialog.close(); document.body.classList.remove('seven-finder-open'); }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["24seven-glass"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = `[data-seven-glass], .header, .menu-list__submenu-inner, .menu-drawer, .menu-drawer__submenu, .search-modal__content, .theme-drawer__dialog, .quick-add-modal, .product-card, .product-details, .facets__form, .cart__summary, .product-information__media, .product-details .group-block[class*='color-custom-'], .seven-page-page #MainContent .section-content-wrapper:not(:has(.section-content-wrapper)), .shopify-policy__container, .seven-editorial__instagram, .seven-editorial__pause, .seven-editorial__product-cta, .seven-finder__close, .seven-finder__chips button, .menu-drawer__close-button, footer`;
  const pointer = matchMedia('(hover: hover) and (pointer: fine)');
  const touchLayout = matchMedia('(max-width: 749px), (hover: none) and (pointer: coarse)');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const visibleSurfaces = new Map();
  const surfaces = new Set();
  // Limit simultaneous moving surfaces to two; the remaining glass keeps its soft tint.
  const updateFlow = () => {
    const moving = touchLayout.matches && !reducedMotion.matches
      ? [...visibleSurfaces].sort((a, b) => b[1] - a[1]).slice(0, 2).map(([surface]) => surface)
      : [];
    for (const surface of surfaces) {
      surface.classList.toggle('seven-glass-flow', touchLayout.matches);
      surface.classList.toggle('seven-glass-flow--active', moving.includes(surface));
    }
  };
  const flowObserver = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting) visibleSurfaces.set(entry.target, entry.intersectionRect.width * entry.intersectionRect.height);
      else visibleSurfaces.delete(entry.target);
    }
    updateFlow();
  }, { threshold: [0, .15, .5, 1] });
  const observeFlow = () => {
    for (const surface of surfaces) {
      if (!surface.isConnected) { flowObserver.unobserve(surface); surfaces.delete(surface); visibleSurfaces.delete(surface); }
    }
    document.querySelectorAll(selector).forEach(surface => {
      if (surfaces.has(surface)) return;
      surfaces.add(surface);
      flowObserver.observe(surface);
    });
    updateFlow();
  };
  observeFlow();
  document.addEventListener('shopify:section:load', observeFlow);
  touchLayout.addEventListener('change', updateFlow);
  reducedMotion.addEventListener('change', updateFlow);
  document.addEventListener('visibilitychange', () => document.body.classList.toggle('seven-flow-paused', document.hidden));
  let active = null;
  let frame = 0;
  let x = 0;
  let y = 0;
  const clear = () => {
    cancelAnimationFrame(frame);
    frame = 0;
    if (active) {
      active.style.removeProperty('--seven-glow');
      active.style.removeProperty('--seven-glass-x');
      active.style.removeProperty('--seven-glass-y');
    }
    active = null;
  };
  const paint = () => {
    frame = 0;
    if (!active?.isConnected) return clear();
    const bounds = active.getBoundingClientRect();
    active.style.setProperty('--seven-glass-x', `${x - bounds.left}px`);
    active.style.setProperty('--seven-glass-y', `${y - bounds.top}px`);
    active.style.setProperty('--seven-glow', '1');
  };
  document.addEventListener('pointermove', event => {
    if (!pointer.matches || touchLayout.matches || event.pointerType === 'touch') return clear();
    const surface = event.target instanceof Element ? event.target.closest(selector) : null;
    if (surface !== active) {
      clear();
      active = surface;
    }
    if (!active) return;
    x = event.clientX;
    y = event.clientY;
    if (!frame) frame = requestAnimationFrame(paint);
  }, { passive: true });
  document.addEventListener('pointerout', event => { if (!event.relatedTarget) clear(); }, { passive: true });
  document.addEventListener('scroll', clear, { capture: true, passive: true });
  document.addEventListener('visibilitychange', clear);
  window.addEventListener('blur', clear);
  pointer.addEventListener('change', clear);
})();
/* Smooth desktop wheel input without replacing native touch or nested scrolling. */
(() => {
  if (!document.body.classList.contains('seven-glass-store')) return;
  const pointer = matchMedia('(hover: hover) and (pointer: fine)');
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  let frame = 0, target = 0, lastTime = 0;
  const stop = () => {
    cancelAnimationFrame(frame);
    frame = 0;
    lastTime = 0;
  };
  const limit = () => Math.max(0, document.documentElement.scrollHeight - innerHeight);
  const animate = time => {
    const elapsed = lastTime ? Math.min(48, time - lastTime) : 16.67;
    lastTime = time;
    target = Math.max(0, Math.min(limit(), target));
    const distance = target - scrollY;
    if (Math.abs(distance) < .75) {
      window.scrollTo({top: target, behavior: 'instant'});
      stop();
      return;
    }
    const progress = 1 - Math.exp(-elapsed / 85);
    window.scrollTo({top: scrollY + distance * progress, behavior: 'instant'});
    frame = requestAnimationFrame(animate);
  };
  document.addEventListener('wheel', event => {
    if (!pointer.matches || motion.matches || !event.cancelable || event.defaultPrevented ||
        event.ctrlKey || event.metaKey || event.altKey || event.shiftKey ||
        Math.abs(event.deltaX) > Math.abs(event.deltaY) || !event.deltaY) return;
    const bodyStyle = getComputedStyle(document.body);
    if (bodyStyle.overflowY === 'hidden' || bodyStyle.position === 'fixed' ||
        document.querySelector('dialog[open], .menu-drawer-container[open]')) return;
    for (let node = event.target; node instanceof Element && node !== document.body; node = node.parentElement) {
      if (node.matches('input, textarea, select, [contenteditable="true"]')) return;
      if (node.scrollHeight > node.clientHeight + 1 && /auto|scroll|overlay/.test(getComputedStyle(node).overflowY)) return;
    }
    const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? innerHeight : 1;
    const delta = Math.max(-innerHeight, Math.min(innerHeight, event.deltaY * unit));
    if (!frame) target = scrollY;
    // An opposite wheel gesture changes direction immediately.
    if ((target - scrollY) * delta < 0) target = scrollY;
    const next = Math.max(0, Math.min(limit(), target + delta));
    if (next === target && !frame) return;
    event.preventDefault();
    target = next;
    if (!frame) frame = requestAnimationFrame(animate);
  }, {passive: false});
  window.addEventListener('keydown', event => {
    if (['ArrowUp','ArrowDown','PageUp','PageDown','Home','End',' ','Tab'].includes(event.key)) stop();
  });
  window.addEventListener('pointerdown', stop, {passive: true});
  window.addEventListener('resize', stop, {passive: true});
  window.addEventListener('blur', stop);
  document.addEventListener('visibilitychange', stop);
  pointer.addEventListener('change', stop);
  motion.addEventListener('change', stop);
})();
  } catch(e) { console.error(e); }
})();

})();
